<template>
    <div class="back-button">
        <router-link :to="location" class="back-link"><img :src="backButtonImage" /></router-link>
    </div>
</template>

<script>

    import backButtonImage from '../assets/images/back.svg';

    export default {
        name: "back-button",
        props: {
            location: String
        },
        data: function() {
            return {
                backButtonImage
            };
        }
    }
</script>

<style scoped lang="scss">
    .back-button {
        grid-area: back;
        align-self: center;
        justify-self: end;
        background: $dark-blue;
        margin: 0 16px;
        border-radius: 50%;
        transition: 0.2s;

        &:hover {
            background: $green;
        }

        .back-link {
            width: 56px;
            height: 56px;
            display: grid;
            align-content: center;
            justify-content: center;
            text-decoration: none;
            color: white;

            img {
                height: 32px;
                width: 32px;
            }
        }
    }
</style>